<template>
  <div class="simple-rich-editor">
    <div class="editor-toolbar">
      <button type="button" class="toolbar-btn" :class="{ active: isActive('bold') }" @click="exec('bold')" title="加粗"><b>B</b></button>
      <button type="button" class="toolbar-btn" :class="{ active: isActive('italic') }" @click="exec('italic')" title="斜体"><i>I</i></button>
      <button type="button" class="toolbar-btn" :class="{ active: isActive('underline') }" @click="exec('underline')" title="下划线"><u>U</u></button>
      <span class="toolbar-divider"></span>
      <button type="button" class="toolbar-btn" @click="exec('insertUnorderedList')" title="无序列表"><i class="el-icon-s-unfold"></i></button>
      <button type="button" class="toolbar-btn" @click="exec('insertOrderedList')" title="有序列表"><i class="el-icon-s-fold"></i></button>
      <span class="toolbar-divider"></span>
      <button type="button" class="toolbar-btn" @click="exec('removeFormat')" title="清除格式"><i class="el-icon-brush"></i></button>
    </div>
    <div
      ref="editor"
      class="editor-content"
      contenteditable="true"
      @input="onInput"
      @blur="onBlur"
      v-html="innerValue"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SimpleRichEditor',
  props: {
    value: { type: String, default: '' }
  },
  data() {
    return {
      innerValue: this.value,
      isFocused: false
    }
  },
  watch: {
    value(val) {
      const editorHtml = this.$refs.editor ? this.$refs.editor.innerHTML : ''
      if (val !== editorHtml) {
        this.innerValue = val
      }
    }
  },
  methods: {
    exec(command, value = null) {
      document.execCommand(command, false, value)
      this.$refs.editor.focus()
      this.emitChange()
    },
    isActive(command) {
      return document.queryCommandState(command)
    },
    onInput() {
      this.emitChange()
    },
    onBlur() {
      this.emitChange()
    },
    emitChange() {
      const html = this.$refs.editor.innerHTML
      this.$emit('input', html)
    }
  }
}
</script>

<style scoped>
.simple-rich-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}
.toolbar-btn {
  width: 28px;
  height: 28px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #606266;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.toolbar-btn:hover {
  background: #e4e7ed;
  border-color: #c0c4cc;
}
.toolbar-btn.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}
.toolbar-divider {
  width: 1px;
  height: 18px;
  background: #dcdfe6;
  margin: 0 4px;
}
.editor-content {
  min-height: 120px;
  padding: 12px;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
  outline: none;
}
.editor-content:empty:before {
  content: attr(placeholder);
  color: #c0c4cc;
}
.editor-content >>> ul,
.editor-content >>> ol {
  padding-left: 20px;
  margin: 8px 0;
}
.editor-content >>> p {
  margin: 0 0 8px 0;
}
.editor-content >>> p:last-child {
  margin-bottom: 0;
}
</style>
